import { render, staticRenderFns } from "./ui-progress-bar-component.vue?vue&type=template&id=637671f9&scoped=true&"
import script from "./ui-progress-bar-component.vue?vue&type=script&lang=ts&"
export * from "./ui-progress-bar-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-progress-bar-component.vue?vue&type=style&index=0&id=637671f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637671f9",
  null
  
)

export default component.exports